import React from "react"
import {
	Grid,
	Typography,
	Tooltip
} from "@material-ui/core"
import {
	InfoOutlined as InfoIcon
} from "@material-ui/icons"

import {
	Portlet,
	Divider
} from "@/components"

import {
	Skeleton
} from "@material-ui/lab"

import useCustomStyles from "@/styles/custom"
import useStyles from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/QueueMetrics/QueueMetricsCard/styles"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

type QueueMetricsCardProps = {
	title: string
	icon: React.ReactNode
	iconBackgroundColor: string
	mainColor: string
	count: number
	helperText: string | React.ReactFragment
	countDescription: string
	loading: boolean
	showTooltip?: boolean
}

const QueueMetricsCard: React.FC<QueueMetricsCardProps> = (props) => {
	const {
		count,
		countDescription,
		helperText,
		icon,
		iconBackgroundColor,
		mainColor,
		title,
		showTooltip,
		loading = false
	} = props

	const customClasses = useCustomStyles()
	const classes = useStyles()

	return (
		<Portlet
			style={{
				width: 200
			}}
		>
			<Grid
				container
				spacing={2}
				justifyContent="center"
			>
				<Grid
					item
					xs={12}
				>
					<Grid
						container
						justifyContent="space-between"
						alignItems="center"
					>
						<Typography
							variant="h2"
							className={customClasses.uppercase}
						>
							{title}
						</Typography>

						{showTooltip && <Tooltip
							title={helperText}
						>
							<InfoIcon
								htmlColor={colors.gray[400]}
								className={classes.iconStyle}
							/>
						</Tooltip>}
					</Grid>
				</Grid>

				<Grid
					item
					xs={12}
				>
					<Grid
						container
						alignItems="center"
						justifyContent="center"
						direction="column"
						className={classes.dataContainer}
					>
						<Grid
							className={classes.iconContainer}
							style={{
								...ColorUtil.getBackgroundAndContrastColor(iconBackgroundColor)
							}}
							container
							alignItems="center"
							justifyContent="center"
						>
							{React.cloneElement(icon as React.ReactElement, {
								style: {
									color: mainColor
								}
							})}
						</Grid>

						<Divider orientation="horizontal" size={3} />

						{ loading ? (
							<Skeleton height={27} width={60} variant="rect" style={{ borderRadius: 4 }}/>
						) : (
							<Typography
								className={classes.count}
								style={{
									color: mainColor
								}}
							>
								{count}
							</Typography>
						)
						}

						<Divider orientation="horizontal" size={1} />

						<Typography
							variant="caption"
							style={{
								color: mainColor
							}}
						>
							{countDescription}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default QueueMetricsCard
